import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { PaymentMethod } from '../paymentMethod.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(params?: QueryParams): Observable<PaymentMethod> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<PaymentMethod>(`${this.apiRoot}/${account_id}/api/payment_method`, { params }),
      ),
    );
  }

  update(body: Partial<PaymentMethod>, params?: QueryParams): Observable<PaymentMethod> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<PaymentMethod>(`${this.apiRoot}/${account_id}/api/payment_method`, body, { params }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('PaymentMethod', downgradeInjectable(PaymentMethodsResource));
